import { isReadOnlySelector } from 'modules/MedComms/selectors';
import React from 'react';
import { useSelector } from 'react-redux';
import AssetsCollectionScreen from 'components/AssetsCollectionScreen';
import { SCREEN_TO_EXCLUDE } from 'const/MedComms/Screen';
import * as Models from 'models';
import styles from './styles.module.scss';

type Props = {
  document: Models.AssetsCollectionMap;
  showScreenDetails(previewUrl: string): void;
  dataTestId?: string;
};

const AssetsCollectionScreens: React.FC<Props> = ({
  document,
  showScreenDetails,
  dataTestId = 'assetsCollectionScreens',
}) => {
  const entities = (document as Models.StoryCardMap).get('entities');
  const screens = entities?.get('screens');
  const screenIds = entities?.get('screenIds');
  const isReadOnly = useSelector(isReadOnlySelector);

  if (!screens) {
    return null;
  }

  return (
    <ul className={styles.AssetsCollectionScreens} data-testid={dataTestId}>
      {screenIds?.toArray()
        .map((screenId, index) => {
          const screen = screens.get(screenId);

          return (
            (isReadOnly && screen.get('name') === SCREEN_TO_EXCLUDE.RULES) ? <></>
            : <li key={screenId} className={styles.item} data-testid={`${dataTestId}-item${String(index)}`}>
              <AssetsCollectionScreen
                document={document}
                screen={screen}
                screenOrder={index + 1}
                showDetails={showScreenDetails}
                dataTestId={`${dataTestId}-screen${String(index)}`}
              />
            </li>
          );
        })}
    </ul>
  );
};

export default AssetsCollectionScreens;
